import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "testui-enabled";

const TestUIContext = createContext(null);

const readInitialValue = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const TestUIProvider = ({ children }) => {
  const [isTestUIEnabled, setIsTestUIEnabled] =
    useState(readInitialValue);

  const toggleTestUI = () => {
    setIsTestUIEnabled((current) => {
      const nextValue = !current;

      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          nextValue.toString(),
        );
      } catch {
        // Swallow storage errors – UI state still updates locally.
      }

      return nextValue;
    });
  };

  const contextValue = {
    isTestUIEnabled,
    toggleTestUI,
  };

  return (
    <TestUIContext.Provider value={contextValue}>
      {children}
    </TestUIContext.Provider>
  );
};

export const useTestUI = () => {
  const context = useContext(TestUIContext);

  if (!context) {
    throw new Error("useTestUI must be used within a TestUIProvider");
  }

  return context;
};
